<template>
    <div class="main-content">
        <h1>
            <translate>My objectives/goals</translate>
            <router-link :to="{name: 'plan-new-objective-goal'}" class="button button--primary float-right">
                <translate>Plan new objective/goal</translate>
            </router-link>
        </h1>
        <div class="main-content__my-objectives-goals">
            <div class="content-navigation">
                <ul class="content-navigation__container">
                    <li><a href="javascript:;" class="content-navigation__link"
                           v-bind:class="{ 'content-navigation__link--active' : tab_location == 'in-progress' }"
                           @click="tab_location = 'in-progress'" v-translate>In progress</a></li>
                    <li><a href="javascript:;" class="content-navigation__link"
                           v-bind:class="{ 'content-navigation__link--active' : tab_location == 'completed' }"
                           @click="tab_location = 'completed'" v-translate>Completed</a></li>
                </ul>
            </div>
            <div class="planned-objective__list" v-if="tab_location == 'in-progress'">
                <objective v-for="(objective, i) in in_progress_objectives" :objective="objective" :key="'in_progress_obj'+i"/>
                <div v-if="in_progress_objectives.length == 0" class="empty-list" v-translate>
                    There are currently no objectives in progress.
                </div>
            </div>
            <div class="planned-objective__list" v-if="tab_location == 'completed'">
                <objective v-for="(objective, i) in completed_objectives" :objective="objective" :key="'completed_obj'+i"/>
                <div v-if="completed_objectives.length == 0" class="empty-list" v-translate>
                    You did not complete any objectives yet.
                </div>
            </div>
            <hr>
            <div class="clearfix">
                <router-link :to="{name: 'plan-new-objective-goal'}" class="button button--primary float-right">
                    <translate>Plan new objective/goal</translate>
                </router-link>
            </div>

            <!-- ZQ YOUR ROADMAP -->
            <roadmap>a</roadmap>
            <!-- // END ZQ YOUR ROADMAP -->
        </div>
    </div>
</template>

<script>
    import ActivityPopup from './popups/ActivityPopup'
    import MarkAsCompletedPopup from './popups/MarkAsCompletedPopup'
    import {mapActions} from 'vuex';
    import MarkAsNotCompletedPopup from "./popups/MarkAsNotCompletedPopup";
    import {EventBus} from "../event-bus";
    import axios from 'axios';
    import Objective from "./Objective";
    import Roadmap from "./Roadmap";
    import PackageFeatureRequired from "../mixins/PackageFeatureRequired";

    export default {
        name: 'Planning-MyObjectivesGoals',
        components: {Roadmap, Objective},
        mixins: [PackageFeatureRequired('plan_your_objectives')],
        data() {
            return {
                objectives: [],
                tab_location: 'in-progress',
                activity_popup: ActivityPopup,
                mark_as_completed_popup: MarkAsCompletedPopup,
                mark_as_not_completed_popup: MarkAsNotCompletedPopup
            }
        },
        methods: {
            ...mapActions([
                'openPopup'
            ]),
            loadObjectives: async function () {
                this.objectives = (await axios.get('/api/navigator/objectives/')).data
            }
        },
        computed: {
            in_progress_objectives: function () {
                return this.objectives.filter(objective => objective.activities_count !== objective.completed_activities_count)
            },
            completed_objectives: function () {
                return this.objectives.filter(objective => objective.activities_count === objective.completed_activities_count)
            }
        },
        beforeMount: async function () {
            await this.loadObjectives()
        },
        created: function () {
            EventBus.$on('refresh_activities', this.loadObjectives)
        },
        beforeDestroy: function () {
            EventBus.$off('refresh_activities')
        }
    }
</script>